import { CdkAccordion, CdkAccordionItem } from '@angular/cdk/accordion';
import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ENVIRONMENT } from '../../../../../environments/environment.interface';
import { Relative } from '../../../../api/app-types/relative.app';
import { OtherRelativesItem } from '../other-relatives-item/other-relatives-item';

@Component({
	selector: 'lvr-other-relatives-list',
	templateUrl: './other-relatives-list.html',
	styleUrl: './other-relatives-list.scss',
	imports: [CdkAccordion, CdkAccordionItem, TranslocoPipe, OtherRelativesItem, RouterLink],
})
export class OtherRelativesList {
	public readonly env = inject(ENVIRONMENT);
	public readonly relatives = input.required<Relative[]>();
	public readonly title = input.required<string>();
}
